// Branding Configuration
// Change ACTIVE_BRAND to switch between different white-label brands

export const BRANDING = {
  ALH_GROUP: {
    name: 'ALH Group',
    displayName: 'ALH Group',
    templateId: '4GirEL1WcY-vA1gN_0q8s',
    logo: 'https://images.squarespace-cdn.com/content/v1/588abde35016e12082207796/05fba812-6d68-4b9f-9353-c1a5ee5feb1e/ALH_Group_Logo_Transparent.png',
    colors: {
      primary: '#003263',
      secondary: '#f6cd59',
      primaryHover: '#004080',
      secondaryHover: '#e5bc48'
    },
    links: {
      website: 'https://www.alhgroup.com.au/',
      contact: 'https://www.alhgroup.com.au/contact/'
    },
    // Card payload structure for this brand
    buildCardPayload: (documentData) => ({
      email: 'demo@idvpacific.com.au',
      membershipNo: String(Math.floor(Math.random() * 900000) + 100000),
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || ''
    })
  },
  
  MAX_GAMING: {
    name: 'MAX_GAMING',
    displayName: 'MAX Gaming',
    templateId: '2K14v1NQaGwyFVEbpyphh',
    logo: 'https://max.com.au/wp-content/uploads/2023/05/MAX-logo.png',
    colors: {
      primary: '#5B3A7D',
      secondary: '#E63946',
      primaryHover: '#7B5A9D',
      secondaryHover: '#D62839'
    },
    links: {
      website: 'https://max.com.au/',
      contact: 'https://max.com.au/contact/'
    },
    // Card payload structure for this brand
    buildCardPayload: (documentData) => ({
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || '',
      email: 'demo@idvpacific.com.au',
      phone: '+611234567890',
      memberId: Math.floor(Math.random() * 900000) + 100000,
      pointsKey: 1000,
      membershipType: 'VIP Member'
    })
  },
  
  IDV_PACIFIC: {
    name: 'IDV_PACIFIC',
    displayName: 'IDV Pacific',
    templateId: 'eyaEuEx6TO02LOb5rFx-o',
    logo: 'https://idvpacific.com.au/wp-content/uploads/2018/09/IVD-Logo-retina.png',
    colors: {
      primary: '#0066CC',
      secondary: '#006abc',
      primaryHover: '#0052a3',
      secondaryHover: '#005599'
    },
    links: {
      website: 'https://idvpacific.com.au/',
      contact: 'https://idvpacific.com.au/contact/'
    },
    // Card payload structure for this brand
    buildCardPayload: (documentData) => ({
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || '',
      email: documentData.email || 'demo@idvpacific.com.au',
      dateOfBirth: documentData.dateOfBirth || new Date().toISOString()
    })
  },

  NEXTPAYMENT: {
    name: 'NEXTPAYMENT',
    displayName: 'Next Payment',
    templateId: 'WRglmT8PpgJFhRTHXEEYD',
    logo: 'https://cdn.prod.website-files.com/611ee63d305165bc92714287/618334032e54661974d9509b_next-payments.svg',
    colors: {
      primary: '#393838',
      secondary: '#393838',
      primaryHover: '#2a2929',
      secondaryHover: '#2a2929'
    },
    links: {
      website: 'https://nextpayment.com/',
      contact: 'https://nextpayment.com/contact/'
    },
    // Card payload structure for this brand (same as MAX_GAMING)
    buildCardPayload: (documentData) => ({
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || '',
      email: 'demo@idvpacific.com.au',
      phone: '+611234567890',
      memberId: Math.floor(Math.random() * 900000) + 100000,
      pointsKey: 1000,
      membershipType: 'VIP Member'
    })
  },

  BARE_MEDIA: {
    name: 'BARE_MEDIA',
    displayName: 'Bare Media',
    templateId: 'eyaEuEx6TO02LOb5rFx-o', // Same as IDV Pacific
    logo: 'https://cdn.prod.website-files.com/674ea38e6fcad82e84e3705d/6825e5d07d2953f8535bf96f_image_7.png',
    colors: {
      primary: '#14131b',
      secondary: 'linear-gradient(#f2bbe3, #db88f2)',
      primaryHover: '#14131b',
      secondaryHover: 'linear-gradient(#f2bbe3, #db88f2)'
    },
    links: {
      website: 'https://baremedia.com/',
      contact: 'https://baremedia.com/contact/'
    },
    // Card payload structure for this brand (same as IDV Pacific)
    buildCardPayload: (documentData) => ({
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || '',
      email: documentData.email || 'demo@idvpacific.com.au',
      dateOfBirth: documentData.dateOfBirth || new Date().toISOString()
    })
  },

  AAA: {
    name: 'AAA',
    displayName: 'Australian Automobile Association',
    templateId: 'DfJGeIL8bZUxT_8VSkRZq',
    logo: require('./AAA Logo Black.png'),
    colors: {
      primary: '#FEC32C',
      secondary: '#FEC32C',
      primaryHover: '#e5b028',
      secondaryHover: '#e5b028'
    },
    links: {
      website: 'https://www.aaa.asn.au/',
      contact: 'https://www.aaa.asn.au/advocacy/'
    },
    // Card payload structure for this brand (same as MAX_GAMING)
    buildCardPayload: (documentData) => ({
      firstName: documentData.firstName || '',
      lastName: documentData.lastName || '',
      email: 'demo@idvpacific.com.au',
      phone: '+611234567890',
      memberId: Math.floor(Math.random() * 900000) + 100000,
      pointsKey: 1000,
      membershipType: 'VIP Member'
    })
  }
};

// ========================================
// CHANGE THIS TO SWITCH BRANDS IDV_PACIFIC ALH_GROUP MAX_GAMING NEXTPAYMENT BARE_MEDIA AAA    
// ========================================
export const ACTIVE_BRAND = BRANDING.AAA;

// Helper function to build the complete card request
export const buildDigitalCardRequest = (documentData) => ({
  templateId: ACTIVE_BRAND.templateId,
  cardPayload: ACTIVE_BRAND.buildCardPayload(documentData),
  options: {
    downloadId: null,
    emailInvitationEnabled: true,
    smsInvitationEnabled: false
  }
});
